/**
 * Tulia Referral Page — copy-to-clipboard + share
 * Issue: #26
 *
 * IIFE pattern matching tulia-product-card.js.
 * Event delegation on document body for robustness.
 */
(function () {
  'use strict';

  var COPY_BTN = '[data-referral-copy]';
  var SHARE_BTN = '[data-referral-share]';
  var CODE_EL = '[data-referral-code]';

  /**
   * Get the referral code string from the DOM.
   */
  function getCode() {
    var el = document.querySelector(CODE_EL);
    return el ? el.textContent.trim() : '';
  }

  /**
   * Copy referral code to clipboard.
   * Falls back to execCommand for older browsers.
   */
  function handleCopy(btn) {
    var code = getCode();
    if (!code) return;

    var originalText = btn.textContent;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(function () {
        showCopied(btn, originalText);
      });
    } else {
      /* Fallback for older browsers */
      var textarea = document.createElement('textarea');
      textarea.value = code;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        showCopied(btn, originalText);
      } catch (e) {
        /* silent fail */
      }
      document.body.removeChild(textarea);
    }
  }

  /**
   * Briefly show "Copied!" feedback on the button.
   */
  function showCopied(btn, originalText) {
    btn.textContent = 'Copied!';
    btn.classList.add('is-copied');
    setTimeout(function () {
      btn.textContent = originalText;
      btn.classList.remove('is-copied');
    }, 2000);
  }

  /**
   * Handle share button clicks.
   * Uses Web Share API if available, otherwise falls back to per-channel actions.
   */
  function handleShare(btn) {
    var code = getCode();
    if (!code) return;

    var channel = btn.getAttribute('data-referral-share');
    var shareText = 'Here\u2019s $10 off your first order at Tulia Scrubs! Use my code ' + code + ' at checkout.';
    var shareUrl = 'https://tuliascrubs.com?ref=' + encodeURIComponent(code);

    switch (channel) {
      case 'native':
        /* Web Share API — mobile-first */
        if (navigator.share) {
          navigator.share({
            title: 'Tulia Scrubs — $10 Off',
            text: shareText,
            url: shareUrl
          }).catch(function () { /* user cancelled */ });
        }
        break;

      case 'email':
        var subject = encodeURIComponent('$10 off Tulia Scrubs — from me to you');
        var body = encodeURIComponent(shareText + '\n\nShop now: ' + shareUrl);
        window.location.href = 'mailto:?subject=' + subject + '&body=' + body;
        break;

      case 'sms':
        var smsBody = encodeURIComponent(shareText + ' ' + shareUrl);
        /* iOS uses &body=, Android uses ?body= — use & for broadest compat */
        window.location.href = 'sms:?&body=' + smsBody;
        break;

      case 'facebook':
        window.open(
          'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(shareUrl),
          '_blank',
          'width=600,height=400'
        );
        break;

      case 'copy-link':
        var fullLink = shareUrl;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(fullLink).then(function () {
            showCopied(btn, btn.getAttribute('data-original-text') || btn.textContent);
          });
        }
        break;
    }
  }

  /**
   * Main click handler — event delegation.
   */
  function handleClick(e) {
    var copyBtn = e.target.closest(COPY_BTN);
    if (copyBtn) {
      e.preventDefault();
      handleCopy(copyBtn);
      return;
    }

    var shareBtn = e.target.closest(SHARE_BTN);
    if (shareBtn) {
      e.preventDefault();
      handleShare(shareBtn);
      return;
    }
  }

  function init() {
    document.addEventListener('click', handleClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
